"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var react_dropzone_1 = require("react-dropzone");

var react_2 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var UploadArea = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px dashed lightgrey;\n  padding: 5px;\n  text-align: center;\n  border-radius: 2px;\n  background-color: #efefef;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 80px;\n  cursor: pointer;\n"], ["\n  border: 1px dashed lightgrey;\n  padding: 5px;\n  text-align: center;\n  border-radius: 2px;\n  background-color: #efefef;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 80px;\n  cursor: pointer;\n"])));

var getBase64 = function getBase64(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function () {
      return resolve(reader.result);
    };

    reader.onerror = function (error) {
      return reject(error);
    };
  });
};

exports.ImageUpload = function (_a) {
  var children = _a.children,
      onUpload = _a.onUpload;
  var onDrop = react_1.useCallback(function (files) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        console.log('Files', files);
        files.forEach(function (file) {
          return __awaiter(void 0, void 0, void 0, function () {
            var data, _a;

            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  _a = files.length;
                  if (!_a) return [3
                  /*break*/
                  , 2];
                  return [4
                  /*yield*/
                  , getBase64(file)];

                case 1:
                  _a = _b.sent();
                  _b.label = 2;

                case 2:
                  data = _a;
                  if (!data) return [3
                  /*break*/
                  , 4];
                  return [4
                  /*yield*/
                  , onUpload(data, file)];

                case 3:
                  _b.sent();

                  _b.label = 4;

                case 4:
                  return [2
                  /*return*/
                  ];
              }
            });
          });
        });
        return [2
        /*return*/
        ];
      });
    });
  }, []);

  var _b = react_dropzone_1.useDropzone({
    onDrop: onDrop
  }),
      getRootProps = _b.getRootProps,
      getInputProps = _b.getInputProps,
      isDragActive = _b.isDragActive;

  return react_2.default.createElement("div", __assign({}, getRootProps()), react_2.default.createElement("input", __assign({}, getInputProps())), children || react_2.default.createElement(UploadArea, null, isDragActive ? react_2.default.createElement("div", null, "Drop the image here ...") : react_2.default.createElement("div", null, "Drag 'n' drop the image here, or click to upload the image")));
};

var templateObject_1;